import { render, staticRenderFns } from "./FollowUp.vue?vue&type=template&id=cd8c460c"
import script from "./FollowUp.vue?vue&type=script&lang=js"
export * from "./FollowUp.vue?vue&type=script&lang=js"
import style0 from "./FollowUp.vue?vue&type=style&index=0&id=cd8c460c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports